import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d6b4f4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-view" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_icon, { name: "success" })
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$route.query.tip), 1)
  ]))
}